import React, { useState, useEffect } from 'react';
import { useRouter } from 'next/router';
import Accordion from '@material-ui/core/Accordion';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import Typography from '@material-ui/core/Typography';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import TextField from '@material-ui/core/TextField';
import IconButton from '@material-ui/core/IconButton';
import SearchIcon from '@material-ui/icons/Search';
import CancelRoundedIcon from '@material-ui/icons/CancelRounded';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
import ListItemText from '@material-ui/core/ListItemText';
import Checkbox from '@material-ui/core/Checkbox';
import PerfectScrollbar from 'react-perfect-scrollbar';
import { getDocs, collection } from 'firebase/firestore/lite';
import { firebaseFireStore } from '../../config/firebaseFirestore';

let backedCollectionsArr = [];

export default function CollectionComponent(props) {
  const router = useRouter();
  let { collection: collectionFilter } = router.query;

  const [collectionField, setcollectionField] = useState('');
  const [collectionsList, setcollectionsList] = useState(null);

  useEffect(() => {
    getCollections();
  }, []);

  const getCollections = async () => {
    let dbRef = await getDocs(
      collection(firebaseFireStore, 'musicartCollections'),
    );

    if (!dbRef.empty) {
      let dataArr = [];
      dbRef.forEach((doc) => {
        dataArr.push(doc.data());
      });
      let alpaarr = dataArr.sort(function (a, b) {
        if (a.displayName.toLowerCase() < b.displayName.toLowerCase()) {
          return -1;
        }
        if (a.displayName.toLowerCase() > b.displayName.toLowerCase()) {
          return 1;
        }
        return 0;
      });
      backedCollectionsArr = alpaarr;

      setcollectionsList(alpaarr);
    }
  };
  const searchCollections = async (e) => {
    e.preventDefault();
    let val =
      e && e.target && e.target.value ? e.target.value : collectionField;
    if (val && val !== '') {
      let filterarr = [...backedCollectionsArr];
      let modifiedArr = filterarr.filter((x) =>
        x.name.includes(val.toLowerCase()),
      );

      setcollectionsList(modifiedArr);
    } else {
      setcollectionsList(backedCollectionsArr);
    }
  };

  const collectionSelect = async (option) => {
    let modifiedArr = collectionFilter
      ? Array.isArray(collectionFilter)
        ? [...collectionFilter]
        : [collectionFilter]
      : [];
    if (modifiedArr.includes(option.displayName.toLowerCase())) {
      modifiedArr.splice(
        modifiedArr.indexOf(option.displayName.toLowerCase()),
        1,
      );
    } else {
      modifiedArr.push(option.displayName.toLowerCase());
    }

    props.updateRoute(['collection', modifiedArr], 'addToArr');
  };

  return (
    <div className="filter__group">
      <div className="w-full">
        {collectionsList ? (
        <Accordion className="w-full filter_group_accordion_box">
        <AccordionSummary
          expandIcon={<ExpandMoreIcon fontSize="small" />}
          aria-controls="panel1a-content"
          id="panel1a-header"
        >
          <Typography className="filter_box_title">Collections</Typography>
        </AccordionSummary>
        <AccordionDetails className="flex flex-col" style={{ paddingTop: 0 }}>
          <form onSubmit={(e) => searchCollections(e)}>
            <TextField
              placeholder="Search"
              type="text"
              variant="outlined"
              fullWidth
              list="collections"
              size="small"
              onChange={(e) => {
                let value = e.target.value ? e.target.value : '';
                setcollectionField(e.target.value);
                searchCollections(e);
              }}
              value={collectionField}
              InputProps={{
                endAdornment: (
                  <>
                    {collectionField.length > 0 && (
                      <IconButton
                        aria-label="toggle password visibility"
                        onClick={() => {
                          setcollectionField('');

                          setcollectionsList(backedCollectionsArr);
                        }}
                        size="small"
                      >
                        <CancelRoundedIcon />
                      </IconButton>
                    )}
                    <IconButton
                      aria-label="search"
                      type="submit"
                      size="small"
                    >
                      <SearchIcon />
                    </IconButton>
                  </>
                ),
              }}
            />
          </form>
          <div className="py-3">
            <PerfectScrollbar className="collection_filter_list_box">
            <List dense id="collections">
              {collectionsList && collectionsList.map((option, index2) => {
                const labelId = `checkbox-list-secondary-label-${index2}`;
                return (
                  <ListItem
                    key={index2}
                    button
                    onClick={() => {
                      collectionSelect(option);
                    }}
                  >
                    <ListItemText
                      id={labelId}
                      primary={`${option.displayName}`}
                    />
                    <ListItemSecondaryAction>
                      <Checkbox
                        edge="end"
                        onChange={() => {
                          collectionSelect(option);
                        }}
                        checked={
                          collectionFilter
                            ? Array.isArray(collectionFilter)
                              ? collectionFilter.includes(
                                  option.displayName.toLowerCase(),
                                )
                              : option.displayName.toLowerCase() ===
                                collectionFilter
                            : false
                        }
                        inputProps={{
                          'aria-label': 'primary checkbox',
                        }}
                      />
                    </ListItemSecondaryAction>
                  </ListItem>
                );
              })}
              </List>
            </PerfectScrollbar>
          </div>
        </AccordionDetails>
      </Accordion>
        ) : (
        <div className="w-full filter_group_accordion_box rounded-md">
          <div className='py-4'>
            <div className='flex justify-between px-4'>
              <div className='filter_box_title MuiTypography-body1'>Collections</div>
              <svg focusable="false" width={20} height={20} fill="#0000008a" viewBox="0 0 24 24" aria-hidden="true"><path d="M16.59 8.59L12 13.17 7.41 8.59 6 10l6 6 6-6z"></path></svg>
            </div>
          </div>
      </div>
      )}
      </div>
    </div>
  );
}
